"use client";
import { jsx } from "react/jsx-runtime";
import { useAgent } from "../../../../../utils/agent/AgentProvider.js";
import { useEffect } from "react";
import { Box } from "@mui/material";
import { Button } from "@nxt-costco-com/forge-components";
import { ColorTextLink } from "@nxt-costco-com/forge-design-tokens";
import { addToListActions } from "../../constants.js";
import { useAuth } from "../../../../../hooks/auth/useAuth/index.js";
const SaveToListButton = ({
  dispatch,
  enableModernApis,
  locale,
  msStore,
  product,
  siteValue,
  state
}) => {
  const { getToken, isLoading } = useAuth();
  const { agent } = useAgent();
  const { clientIdLegacy, drawerContent, quantity, selectedLists } = state || {};
  const saveButtonLabel = msStore.getKeyValueItem("savetolistbuttonlabel");
  const saveToWishListError = msStore.getKeyValueItem("addtowishlisterror");
  const saveToWishListSuccess = msStore.getKeyValueItem(
    "addedtowishlistsuccessmessage"
  );
  const savedToListTitle = msStore.getKeyValueItem("savedtolisttitle");
  const selectAListError = msStore.getKeyValueItem("selectalisterror");
  useEffect(() => {
  }, [selectedLists, agent]);
  const handleSaveToListSuccess = async () => {
    const anchoredListNames = selectedLists.map(
      (listItem) => `<a style="color:${ColorTextLink}" href=/ListDetailView?listId=${listItem.value}>${listItem.text}</a>`
    );
    const successMsg = saveToWishListSuccess.replace(
      "{LIST NAMES}",
      anchoredListNames.join(", ")
    );
    dispatch({
      payload: {
        drawerContent: [
          ...drawerContent,
          {
            bodyContent: "savedToListUI",
            hasStickyBar: false,
            successHeaderTitle: true,
            title: savedToListTitle
          }
        ],
        errorMsg: "",
        globalErrorMsg: "",
        isLoading: false,
        selectedLists: [],
        successMsg
      },
      type: addToListActions.UPDATE_STATE
    });
  };
  const handleSaveToList = async () => {
    if (!(selectedLists == null ? void 0 : selectedLists.length)) {
      dispatch({
        payload: {
          globalErrorMsg: selectAListError
        },
        type: addToListActions.UPDATE_STATE
      });
      return;
    }
    const finalQuantity = Number(quantity) ? quantity : "1";
    dispatch({
      payload: {
        isLoading: true,
        quantity: finalQuantity
      },
      type: addToListActions.UPDATE_STATE
    });
    try {
      if (!isLoading) {
        const authCookie = await getToken();
        if (agent && authCookie) {
          if (enableModernApis) {
            agent == null ? void 0 : agent.saveToWishList(
              authCookie,
              finalQuantity,
              product.id,
              selectedLists,
              siteValue
            ).then(handleSaveToListSuccess).catch((err) => {
              console.error(err);
              dispatch({
                payload: {
                  errorMsg: saveToWishListError,
                  globalErrorMsg: "",
                  isLoading: false,
                  selectedLists: []
                },
                type: addToListActions.UPDATE_STATE
              });
            });
          } else {
            const addToLists = async () => {
              for (const list of selectedLists) {
                await agent.addToListLegacy({
                  clientIdLegacy,
                  itemNumber: product.id,
                  listId: list.value,
                  locale,
                  localeModuleKey: siteValue,
                  operationName: "AddItemToWishList",
                  quantity: finalQuantity
                });
              }
            };
            addToLists().then(handleSaveToListSuccess).catch((err) => {
              console.error(err);
              dispatch({
                payload: {
                  errorMsg: saveToWishListError,
                  globalErrorMsg: "",
                  isLoading: false,
                  selectedLists: []
                },
                type: addToListActions.UPDATE_STATE
              });
            });
          }
        }
      } else {
        console.error("Token Utils are not loaded");
      }
    } catch (err) {
      console.error("Token fetch failed");
      console.error(err);
      dispatch({
        payload: {
          errorMsg: saveToWishListError,
          globalErrorMsg: "",
          isLoading: false,
          selectedLists: []
        },
        type: addToListActions.UPDATE_STATE
      });
    }
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
      },
      id: "add-to-list-static-button",
      children: /* @__PURE__ */ jsx(
        Button,
        {
          "aria-label": saveButtonLabel,
          onClick: handleSaveToList,
          variant: "primary",
          children: saveButtonLabel
        }
      )
    }
  );
};
export {
  SaveToListButton
};
